var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Due to a problem with PoseNet this website is not available right now. Please try it out later. ")])}
var staticRenderFns = []

export { render, staticRenderFns }